import React from "react";
import CloseIcon from "@material-ui/icons/Close";

import { FileActionsProps } from "./file-actions.props";
import { useFileActionsStyles } from "./file-actions.styles";
import { IconButton } from "./components/icon-button/icon-button.component";

export const FileActions = (props: FileActionsProps) => {
  const onDelete = () => props.onDelete && props.onDelete(props.asset.id);
  const classes = useFileActionsStyles();

  const { showDeleteButton = true } = props;

  return (
    <div className={classes.rightAligned}>
      <IconButton
        showIf={showDeleteButton}
        disabled={!props.canDelete}
        onClick={onDelete}
        title="Delete"
      >
        <CloseIcon />
      </IconButton>
    </div>
  );
};
